export interface ITabuladorUma {
  id?: string | null;
  umas?: number | null;
  vigencia?: Date | null;
  activo?: boolean | null;
}

export class TabuladorUma implements ITabuladorUma {
  constructor(
    public cvu?: number | null,
    public id?: string | null,
    public umas?: number | null,
    public vigencia?: Date | null,
    public activo?: boolean | null
  ) {}

  static fromObject(data: ITabuladorUma): TabuladorUma {
    const tabuladorUma = new TabuladorUma();
    for (const [key, value] of Object.entries(data)) {
      tabuladorUma[key] = value;
    }

    return tabuladorUma;
  }
}
